const breakpoints = {
  s: '480px',
  m: '768px',
  l: '1200px',
  xl: '1600px',
} as const;

export default breakpoints;
